import yup from '../../../config/yup';

export const anthologyWriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('anthologyWriter'),
  delayedRead: yup.boolean(),
  format: yup.string(),
  // Node-specific properties
  properties: yup.object().shape({
    paginationType: yup.string().oneOf(['QueryString', 'RequestBody', 'Stream']),
    httpMethod: yup.string().oneOf(['GET', 'POST', 'PUT', 'DELETE']),
    acceptInvalidCerts: yup.boolean(),
    url: yup.string(),
    headers: yup.string().transform((value) => value?.trim()),
    body: yup.string().transform((value) => value?.trim()),
    queryString: yup.string().transform((value) => value?.trim()),
  }),
});
